

export function serializeProperties(obj) {
	if (typeof obj !== 'object' || Array.isArray(obj) || obj === null) {
		return obj;
	}

	var objReturn = { };
	Object
		.keys(obj)
		.forEach(key => {
			Object.assign(objReturn, serializeObject(obj, key));
		});

	return objReturn;
}

function serializeObject(object, key) {
	const parsedKey = parseKey(object, key);
	const value = serializePropertyValue(object[parsedKey.value]);

	return { [parsedKey.replace()]: value };
}

function parseKey(obj, key) {
	const removeFirstUnderscore = value => value.replace(/^_/g, '');

	return Object.getOwnPropertyDescriptor(obj, key) === undefined
		? { value: key, replace: () => removeFirstUnderscore(key) }
		: { value: removeFirstUnderscore(key), replace() { return this.value } };
}

function serializePropertyValue(value) {
	if(!!value && typeof value === "object" && !Array.isArray(value))
		return serializeProperties(value);
	else if(Array.isArray(value))
		return value.map(i => typeof i === 'object' ? serializeProperties(i) : i);

	return value;
}

export default {
	serializeProperties,
};
